import { getColorNumberForUserAvatar, getInitials } from "@/domain/user"
import { UserItem } from "@/molecules/UserItem"

export const CreatorCell = (
  displayName: string,
  record?: { ghostCreatorCell?: boolean }
) => (
  <UserItem
    displayOnlyAvatar
    ghost={record?.ghostCreatorCell}
    avatarSize="small"
    email={displayName}
    tooltip={displayName}
    colorNumber={getColorNumberForUserAvatar(displayName)}
    initials={getInitials(displayName)}
  />
)
